<template>
  <div>
    <card-form
      v-bind="$attrs"
      :collapsed="true"
    >
      <template #expanded>
        <div>
          <div class="mb-4 header-card">
            <div>
              <h2 class="title-main">
                {{ title }}
              </h2>
            </div>
            <slot name="headerAction" />
          </div>
          <div>
            <slot />
          </div>
        </div>
      </template>
    </card-form>
  </div>
</template>

<script>
import CardForm from './CardForm.vue'

export default {
  name: 'Card',
  components: {
    CardForm
  },
  props: {
    title: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped lang="scss">
.card-form__container {
  border-radius: 8px;
  padding: 1rem 1.5rem;

  .title-main {
    font-family: 'Exo 2';
    font-size: 0.75rem;
    font-weight: 600;
  }
}

.gap-card {
  gap: 20px 0;
}

.header-card {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: start;

  div {
    flex: 1;
  }
}
</style>
